import { render } from "./UserPurchase.vue?vue&type=template&id=827c9cec"
import script from "./UserPurchase.vue?vue&type=script&lang=js"
export * from "./UserPurchase.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__